/* eslint-disable */

// 文件上传路径
// const fileUploadUrl = 'http://192.168.3.46:7613/aiQaApi/uploadFile'
const fileUploadUrl = 'http://www.linzhi.gov.cn/aiQaApi'

// 文件下载
// const fileDownload = 'http://192.168.3.46:7613/aiQaApi/download'
const fileDownload = 'http://www.linzhi.gov.cn/aiQaApi'
// 导出日志
// const exportLogList = 'http://localhost:7613/exportLogList'

// 本地服务地址
// const local_service_url = 'http://192.168.3.46:7613/aiQaApi'
const local_service_url = 'http://www.linzhi.gov.cn/aiQaApi'
// 生产环境服务地址
// const prod_service_url = 'http://192.168.3.46:7613/aiQaApi'
const prod_service_url = 'http://www.linzhi.gov.cn/aiQaApi'

const auth_uri = 'http://192.168.3.44:8002/cas/oauth2.0/authorize?client_id=znwd-SNAPSHOT_oauth-cid&redirect_uri=http%3A%2F%2F192.168.3.46%3A8075%2Fqaweb%2F%23%2Fsso'

//问答日志接口
// const qaloglocal_service_url = 'http://192.168.3.46:7613'
// const qalogprod_service_url = 'http://192.168.3.46:7613'
export default{
  // exportLogList,
  fileDownload,
  fileUploadUrl,
  local_service_url,
  prod_service_url,
  auth_uri
  // qaloglocal_service_url,
  // qalogprod_service_url,
}



// WEBPACK FOOTER //
// ./src/utils/constant.js